import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Guard against browser-level sandbox IndexedDB backing store errors in iframes
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    if (
      event.reason &&
      (String(event.reason).includes('indexedDB') ||
       String(event.reason).includes('backing store') ||
       String(event.reason?.message).includes('backing store'))
    ) {
      console.warn('Suppressed sandboxed IndexedDB warning:', event.reason);
      event.preventDefault();
    }
  });

  window.addEventListener('error', (event) => {
    if (
      event.message &&
      (event.message.includes('indexedDB') || event.message.includes('backing store'))
    ) {
      console.warn('Suppressed sandboxed IndexedDB error event:', event.message);
      event.preventDefault();
    }
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
